<template>
  <div class="container-fluid p-3">
    <swiper
      ref="reviewsSwiper"
      @swiper="onSwiperInit"
      :slides-per-view="1"
      :space-between="10"
      :loop="true"
      :pagination="{ clickable: true }"
      :breakpoints="{
        640: { slidesPerView: 2, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 40 },
        1024: { slidesPerView: 3, spaceBetween: 34 }
      }"
      :modules="modules"
      class="mySwiper p-3 pt-5"
      id="reviewsCard"
    >
      <swiper-slide
        v-for="review in websiteStore.reviewsCollection.body.feeds"
        :key="review.feedId"
        class="h-auto"
      >
        <div class="col h-100 pt-5" style="cursor: pointer;">
          <div class="row justify-content-center gy-2">
            <div class="col-10 text-center">

              <!-- Foto / Iniciales -->
              <div class="profile-pic mx-auto">
                <div class="initial-circle">
                  {{ obtenerIniciales(review.postAuthorName) }}
                </div>
              </div>

              <h5 class="fw-bold mt-4">{{ review.postAuthorName }}</h5>

              <img src="../../assets/icons/stars.svg" alt="" class="stars my-3" />
            </div>
          </div>

          <div class="row">
            <div class="col-12 p-5 pt-0">
              <p class="card-text">{{ review.postContent }}</p>
            </div>
            <div class="col-12 p-5 pt-0">
                <p class="card-text">{{ formatPostCreatedAt(review.postCreatedAt) }} | <span @click="toReview" class="linkToFacebook">From Facebook</span></p>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>

  <!-- Botones de navegación -->
  <div class="container-fluid px-5 pb-5 d-none d-lg-block">
    <div class="row justify-content-between gallery-btn">
      <div class="col px-4 d-flex" @click="previousSlide">
        <img src="../../assets/icons/arrow_back.svg" class="pe-2" /> Previous
      </div>
      <div class="col text-end px-4" @click="nextSlide">
        Next <img src="../../assets/icons/arrow_forward.svg" class="ps-2" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';

import { useStore } from '@/store/landing';

export default {
  components: { Swiper, SwiperSlide },

  setup() {
    const reviewsSwiper = ref(null);
    const websiteStore = useStore();
    const toReview = () => {
          return window.open('https://www.facebook.com/VacationDealsAllInclusive/reviews', '_blank');
      };
    const formatPostCreatedAt = (unixSeconds) => {
      if(!unixSeconds){
          return '';
        }
      const secondsNumber = Number(unixSeconds);
      const date = new Date(secondsNumber * 1000);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit'
        });
    };
    // Capturar instancia del swiper
    const onSwiperInit = (swiperInstance) => {
      reviewsSwiper.value = swiperInstance;
    };

    const nextSlide = () => {
      if (reviewsSwiper.value) {
        reviewsSwiper.value.slideNext();
      }
    };

    const previousSlide = () => {
      if (reviewsSwiper.value) {
        reviewsSwiper.value.slidePrev();
      }
    };

    const obtenerIniciales = (nombre = '') =>
      nombre
        .trim()
        .split(/\s+/)
        .map(n => n[0].toUpperCase())
        .join('');

    return {
      modules: [Pagination],
      websiteStore,
      reviewsSwiper,
      onSwiperInit,
      nextSlide,
      previousSlide,
      obtenerIniciales,
      toReview,
      formatPostCreatedAt
    };
  }
};
</script>

<style scoped>
:deep(.swiper-pagination) {
    position: relative;
    display: block !important;
    margin-top:7px;
    bottom: 8px;
    text-align: center;
}

:deep(.swiper-pagination-bullet) {
    background: #0C9491;
    opacity: 0.4;
}

:deep(.swiper-pagination-bullet-active) {
    background: #0C9491;
    opacity: 1;
}
.linkToFacebook {
    color: #0C9491;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 28.8px;
}
:deep(.swiper-slide) {
  display: grid !important;
  justify-items: center !important;
  background: #fff;
  box-shadow: 0px 2px 43px -31px rgba(0, 0, 0, 0.75);
  border: none;
}

.card-text {
  text-align:center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.profile-pic {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(180deg, #0b8f8a 0%, #3a2153 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.initial-circle {
  color: #fff;
  font-weight: bold;
  font-size: 1.5rem;
}

.stars {
  width: 130px;
}

#reviewsCard {
  padding-bottom: 40px !important;
}
</style>
